<script setup lang="ts">
interface Props {
  totalLinks: number
  totalCategories: number
}

defineProps<Props>()
</script>

<template>
  <div class="mt-8 p-4 bg-muted rounded-lg text-center text-muted-foreground">
    共 <span class="text-primary font-semibold">{{ totalLinks }}</span> 个工具，
    <span class="text-primary font-semibold">{{ totalCategories }}</span> 个分类
  </div>
</template>
